import i18n from 'config/i18n'
import { GroupedOption, TagOption } from 'state/constants'

interface FormProps {
    comment: string
    tag_uuids: TagOption[]
}
type SetFormPropsFunction = (props: FormProps) => void
type SetGroupOptionsFunction = (cb: (data: GroupedOption[]) => GroupedOption[]) => void

const handleContrastEditOption = (tagOption: TagOption, options: TagOption[]) =>
    options
        ? options.length >= 4
            ? { ...tagOption, isDisabled: true }
            : options.some((option: TagOption) => option.enum.includes('content_quality_too_dark')) &&
                tagOption.enum.includes('content_quality_too_bright')
              ? { ...tagOption, isDisabled: true }
              : options.some((option: TagOption) => option.enum.includes('content_quality_too_bright')) &&
                  tagOption.enum.includes('content_quality_too_dark')
                ? { ...tagOption, isDisabled: true }
                : options.some((option: TagOption) => option.enum.includes('product_too_small')) &&
                    tagOption.enum.includes('product_too_big')
                  ? { ...tagOption, isDisabled: true }
                  : options.some((option: TagOption) => option.enum.includes('product_too_big')) &&
                      tagOption.enum.includes('product_too_small')
                    ? { ...tagOption, isDisabled: true }
                    : { ...tagOption, isDisabled: false }
        : { ...tagOption, isDisabled: false }

export type HandleEditTagChange = (
    options: TagOption[],
    setSubmissionEditTagGroupOptions: SetGroupOptionsFunction,
    setRequestEditFormProps: SetFormPropsFunction,
) => void

export const handleEditTagChange: HandleEditTagChange = (
    options,
    setSubmissionEditTagGroupOptions,
    setRequestEditFormProps,
) => {
    const reason: string = options
        ? options.reduce((memo, option) => {
              return option.enum != 'submission_edits_others_other_reason' ? memo + ' - ' + option.value + '\n' : memo
          }, '')
        : ''

    setSubmissionEditTagGroupOptions((prevData: GroupedOption[]) => {
        return prevData.map(editTagGroupOptions => {
            return {
                ...editTagGroupOptions,
                options: editTagGroupOptions.options.map((tagOption: TagOption) => {
                    return handleContrastEditOption(tagOption, options)
                }),
            }
        })
    })
    setRequestEditFormProps({
        comment: reason,
        tag_uuids: options,
    })
}

const handleContrastRejectOption = (tagOption: TagOption, options: TagOption[]) =>
    options
        ? options.length >= 4
            ? { ...tagOption, isDisabled: true }
            : options.some((option: TagOption) => option.enum.includes('profile_feed_too_dark')) &&
                tagOption.enum.includes('profile_feed_too_bright')
              ? { ...tagOption, isDisabled: true }
              : options.some((option: TagOption) => option.enum.includes('profile_feed_too_bright')) &&
                  tagOption.enum.includes('profile_feed_too_dark')
                ? { ...tagOption, isDisabled: true }
                : options.some((option: TagOption) => option.enum.includes('followers_too_low')) &&
                    tagOption.enum.includes('followers_too_high')
                  ? { ...tagOption, isDisabled: true }
                  : options.some((option: TagOption) => option.enum.includes('followers_too_high')) &&
                      tagOption.enum.includes('followers_too_low')
                    ? { ...tagOption, isDisabled: true }
                    : options.some((option: TagOption) => option.enum.includes('age_too_young')) &&
                        tagOption.enum.includes('age_too_old')
                      ? { ...tagOption, isDisabled: true }
                      : options.some((option: TagOption) => option.enum.includes('age_too_old')) &&
                          tagOption.enum.includes('age_too_young')
                        ? { ...tagOption, isDisabled: true }
                        : options.some((option: TagOption) => option.enum.includes('gender_not_female')) &&
                            tagOption.enum.includes('gender_not_male')
                          ? { ...tagOption, isDisabled: true }
                          : options.some((option: TagOption) => option.enum.includes('gender_not_male')) &&
                              tagOption.enum.includes('gender_not_female')
                            ? { ...tagOption, isDisabled: true }
                            : { ...tagOption, isDisabled: false }
        : { ...tagOption, isDisabled: false }

export type HandleRejectTagChange = (
    options: TagOption[],
    setSubmissionRejectTagGroupOptions: SetGroupOptionsFunction,
    setRejectFormProps: SetFormPropsFunction,
) => void

export const handleRejectTagChange: HandleRejectTagChange = (
    options,
    setSubmissionRejectTagGroupOptions,
    setRejectFormProps,
) => {
    const reason: string =
        options?.length > 0
            ? options.reduce(
                  (memo, option) => {
                      return option.enum != 'submission_rejections_others_other_reason'
                          ? memo + ' - ' + option.value + '\n'
                          : memo
                  },
                  i18n.t('submission.review.rejectionMessageTemplate') + '\n',
              )
            : ''
    setSubmissionRejectTagGroupOptions(prevData => {
        return prevData.map(rejectTagGroupOptions => {
            return {
                ...rejectTagGroupOptions,
                options: rejectTagGroupOptions.options.map((tagOption: TagOption) => {
                    return handleContrastRejectOption(tagOption, options)
                }),
            }
        })
    })
    setRejectFormProps({
        comment: reason,
        tag_uuids: options,
    })
}
